import React, { useEffect } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { FaTimesCircle } from 'react-icons/fa';
import { unlockRazorpayCheckout } from '../../../utils/razorpayCheckout';
import {
  clearStoredPendingOrderPayment,
  persistPendingOrderPayment,
  resolvePendingOrderPayment,
} from './pendingOrderPaymentState';
import { recordPaymentFailure } from './paymentFailureState';
import './PaymentOutcome.css';

const PaymentFailed = () => {
  const { state } = useLocation();
  const navigate = useNavigate();
  const pendingOrderPayment = resolvePendingOrderPayment(state);
  const isResumeMode = Boolean(pendingOrderPayment?.orderNumber);

  const orderNumber =
    pendingOrderPayment?.orderNumber ||
    (typeof state?.orderNumber === 'string' ? state.orderNumber : '');

  const grandTotal =
    pendingOrderPayment?.charges?.grandTotal ??
    pendingOrderPayment?.grandTotal ??
    state?.grandTotal;

  const failureDetail =
    (typeof state?.message === 'string' && state.message.trim()) || '';

  useEffect(() => {
    document.title = 'Payment failed | DigiRasa';
    unlockRazorpayCheckout().catch(() => {});
    if (orderNumber) {
      recordPaymentFailure(orderNumber);
    }
    return () => {
      document.title = 'DigiRasa';
    };
  }, [orderNumber]);

  const handleRetryPayment = () => {
    if (!pendingOrderPayment) {
      navigate('/payment', { replace: true });
      return;
    }
    persistPendingOrderPayment(pendingOrderPayment);
    navigate('/payment', { state: { pendingOrderPayment }, replace: true });
  };

  const handleLeaveForNewOrder = (to) => {
    clearStoredPendingOrderPayment();
    navigate(to, { replace: true });
  };

  return (
    <div className="payment-outcome-page">
      <div className="payment-outcome-card">
        <FaTimesCircle className="payment-outcome-card__icon payment-outcome-card__icon--failed" />
        <h1>Payment failed</h1>

        {orderNumber ? (
          <p className="payment-outcome-card__meta">
            Order <strong>#{orderNumber}</strong>
          </p>
        ) : (
          <p className="payment-outcome-card__meta">Your payment could not be completed.</p>
        )}

        {grandTotal != null && Number.isFinite(Number(grandTotal)) ? (
          <p className="payment-outcome-card__amount">
            Due <strong>₹{Number(grandTotal).toFixed(2)}</strong>
          </p>
        ) : null}

        {failureDetail && failureDetail !== 'Payment was not completed.' ? (
          <p className="payment-outcome-card__hint">{failureDetail}</p>
        ) : (
          <p className="payment-outcome-card__hint">No payment was taken. You can try again below.</p>
        )}

        <div className="payment-outcome-card__actions">
          {isResumeMode ? (
            <button
              type="button"
              className="btn-primary payment-outcome-card__cta"
              onClick={handleRetryPayment}
            >
              Retry payment
            </button>
          ) : (
            <Link to="/payment" className="btn-primary payment-outcome-card__cta">
              Back to payment
            </Link>
          )}

          <button
            type="button"
            className="payment-outcome-card__link payment-outcome-card__link--button"
            onClick={() => handleLeaveForNewOrder('/account/orders')}
          >
            My orders
          </button>

          {!isResumeMode ? (
            <button
              type="button"
              className="payment-outcome-card__link payment-outcome-card__link--button"
              onClick={() => handleLeaveForNewOrder('/our-menu')}
            >
              Continue shopping
            </button>
          ) : null}
        </div>
      </div>
    </div>
  );
};

export default PaymentFailed;
